import { useCallback, useState } from 'react';
import { runCommand } from './commandClient';

export type RunnerStatus = 'idle' | 'saving' | 'waiting';

/** Runs commands and tells the screen whether it's saving, or waiting to retry offline. */
export function useCommandRunner() {
  const [status, setStatus] = useState<RunnerStatus>('idle');

  const run = useCallback(async (type: string, input: unknown, key?: string) => {
    setStatus('saving');
    try {
      return await runCommand(type, input, {
        ...(key ? { key } : {}),
        onWaiting: () => setStatus('waiting'),
      });
    } finally {
      setStatus('idle');
    }
  }, []);

  return { status, run };
}
